import React, { useState } from 'react';
import { dataFetcher } from 'Api';
import styles from './index.module.css';

const formatMoney = (cents) => `$${Math.round((Number(cents) || 0) / 100).toLocaleString('en-US')}`;
const formatDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

const PRESET = {
  canceled: { icon: '×', tone: 'neutral', title: 'Membership ended' },
  expired: { icon: '×', tone: 'neutral', title: 'Membership expired' },
  past_due: { icon: '!', tone: 'warn', title: 'Payment problem' },
  unpaid: { icon: '!', tone: 'warn', title: 'Payment problem' },
  paused: { icon: '‖', tone: 'warn', title: 'Membership paused' },
};

// Shown when is_member is false but the backend still knows the plan:
//   canceled / expired → "ended" + Re-subscribe
//   past_due / unpaid / paused → payment issue + Update card (billing portal)
const MembershipNotice = ({ status, membership, onResubscribe }) => {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const m = membership || {};
  const preset = PRESET[status] || PRESET.canceled;
  const paymentIssue = status === 'past_due' || status === 'unpaid' || status === 'paused';
  const endDate = formatDate(m.current_period_end);
  const planLine = `${m.plan_name || 'Your'} ${m.billing_title || ''}`.trim();
  const priceLine = m.amount_cents ? ` (${formatMoney(m.amount_cents)})` : '';

  const message = paymentIssue
    ? `We couldn't process payment for your ${planLine} membership${priceLine}. Update your card to keep it active.`
    : `Your ${planLine} membership ${status === 'expired' ? 'expired' : 'ended'}${endDate ? ` on ${endDate}` : ''}.`;

  const openPortal = async () => {
    setBusy(true);
    setErr('');
    try {
      const res = await dataFetcher('v4/membership/billing-portal', { return_url: window.location.href });
      if (res?.success && res?.data?.url) {
        window.location = res.data.url;
      } else {
        setErr(res?.message || 'Could not open the billing portal.');
        setBusy(false);
      }
    } catch (e) {
      setErr(e?.response?.data?.message || 'Could not open the billing portal.');
      setBusy(false);
    }
  };

  return (
    <div className={styles.noticeWrap}>
      <div className={`${styles.noticeIcon} ${preset.tone === 'warn' ? styles.noticeIconWarn : styles.noticeIconNeutral}`}>
        {preset.icon}
      </div>
      <h1 className={styles.noticeTitle}>{preset.title}</h1>
      <p className={styles.noticeText}>{message}</p>
      {err && <p className={styles.coError}>{err}</p>}
      <div className={styles.noticeActions}>
        {paymentIssue && (
          <button type="button" className={styles.coPayBtn} onClick={openPortal} disabled={busy}>
            {busy ? 'Opening…' : (status === 'paused' ? 'Manage membership' : 'Update your card')}
          </button>
        )}
        <button
          type="button"
          className={paymentIssue ? styles.coSecondary : styles.coPayBtn}
          onClick={onResubscribe}
          disabled={busy}
        >
          {paymentIssue ? 'Choose a different plan' : 'Re-subscribe'}
        </button>
      </div>
    </div>
  );
};

export default MembershipNotice;
